export default __webpack_public_path__ + "static/media/warehouse-login.e5710a48.png";